import {
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  GridComponent,
  Group,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  Toolbar,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Resize,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import {
  DialogComponent,
  AnimationSettingsModel,
  ButtonPropsModel,
} from '@syncfusion/ej2-react-popups';
import {
  ColorPickerComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import 'react-toastify/dist/ReactToastify.css';
import 'react-jquery-plugin';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import { GetAllTrades } from '../../services/TradePlanner/Trades/TradesServices';
import {
  createTrade,
  getTrades,
  tradeDelete,
  tradeUpdate,
} from '../../services/tradeperson/trades';
import { setTradeDataChanged } from '../../redux/search.slice';
import { connect } from 'react-redux';
import { RootState } from '../../store';
interface IProps {
  tradeDataChanged: boolean;
  setTradeDataChanged: (value: boolean) => void;
}
interface IState {
  TradesData: any;
  hideDialog: boolean;
  inputName: any;
  inputDescription: any;
  trade_type_id: any;
  pickedTradeId: any;
  hideDialogDelete: boolean;
  hideEditDialog: boolean;
  rate1: number;
  rate2: number;
  rate3: number;
  rate4: number;
}
class Teams extends React.Component<IProps, IState> {
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private buttons: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsEdit: ButtonPropsModel[];
  private grid: any;
  private animationSettings: AnimationSettingsModel;
  private valueOfColorPicker: any = '#000000';
  private tradeDataForFilterColor: Array<any> = [];
  constructor(props: IProps) {
    super(props);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttonsEdit = [
      {
        click: () => {
          this.editTrade();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideEditDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTrade();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          this.createTrade();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      hideEditDialog: false,
      hideDialogDelete: false,
      pickedTradeId: '',
      inputName: '',
      inputDescription: '',
      trade_type_id: 0,
      TradesData: [],
      hideDialog: false,
      rate1: 0,
      rate3: 0,
      rate2: 0,
      rate4: 0,
    };
  }
  private dialogOpenDelete(): void {
    this.setState({ hideDialogDelete: true });
  }
  private dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }

  private dialogClose(): void {
    this.setState({
      hideDialog: false,
    });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }
  componentDidMount() {
    this.getTheTrades();
    this.getTradesForColor();
  }
  getTheTrades() {
    getTrades().then((result) => {
      this.setState({ TradesData: result.data });
    });
  }
  getTradesForColor() {
    GetAllTrades().then((res) => {
      this.tradeDataForFilterColor = res.data;
    });
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    // if (prevState.TeamsData !== this.state.TradesData) {
    //   this.tradeservices.getTrades().then((result) => {
    //     this.setState({ TradesData: result.data });
    //   });
    // }
  }

  editTrade() {
    var theElements = this.grid.getSelectedRecords();
    if (theElements.length === 0) {
      Message.error('No record is selected to procced');
      return;
    }
    var tradeCode = this.state.inputName;
    var tradeDescription = this.state.inputDescription;
    var isExistBefore = this.tradeDataForFilterColor.findIndex((el) => {
      return el.color === this.valueOfColorPicker;
    });
    if (tradeCode === '') {
      Message.error('Trade Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (tradeDescription === '') {
      Message.error('Trade Description cannot be empty');
      loadingShow(false);
      return false;
    }

    let obj = {
      trade_code: tradeCode,
      description: tradeDescription,
      trade_type_id: this.state.trade_type_id,
      color: this.valueOfColorPicker,
      trade_id: theElements[0].trade_id,
      rate1: this.state.rate1,
      rate2: this.state.rate2,
      rate3: this.state.rate3,
      rate4: this.state.rate4,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };

    tradeUpdate(obj)
      .then((result) => {
        if (result.status === 200) {
          loadingShow(false);
          Message.success('Edited successfully...');
          this.dialogClose();
          this.getTheTrades();
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Editing failed!!!');
      });

    this.dialogCloseEdit();
  }

  actionComplete(args: any) {
    if (args.requestType === 'save') {
      const updatedRecord = args.data;
      let obj = {
        trade_code: updatedRecord.trade_code,
        description: updatedRecord.description,
        trade_type_id: updatedRecord.trade_type_id,
        color: updatedRecord.color,
        trade_id: updatedRecord.trade_id,
        rate1: updatedRecord.rate1,
        rate2: updatedRecord.rate2,
        rate3: updatedRecord.rate3,
        rate4: updatedRecord.rate4,
        app: 'UWORK',
        created_by: all_information.user_id,
        organization_id: all_information.company_id?.toString(),
        creation_date: new Date(),
      };
      tradeUpdate(obj)
        .then((result) => {
          if (result.status === 200) {
            Message.success('Edited successfully...');
            this.getTheTrades();
          }
        })
        .catch(() => {
          Message.error('Editing failed!!!');
          this.getTheTrades();
        });
    }
  }

  private dialogOpenEdit(): void {
    this.setState({ hideEditDialog: true });
  }
  private dialogCloseEdit(): void {
    this.setState({
      hideEditDialog: false,
    });
  }

  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.setState({ hideDialog: true });
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        const name = this.grid.getSelectedRecords()[0].trade_code;
        const desc = this.grid.getSelectedRecords()[0].description;
        const tradeTypeId = this.grid.getSelectedRecords()[0].trade_type_id;
        const rate1 = this.grid.getSelectedRecords()[0].rate1;
        const rate2 = this.grid.getSelectedRecords()[0].rate2;
        const rate3 = this.grid.getSelectedRecords()[0].rate3;
        const rate4 = this.grid.getSelectedRecords()[0].rate4;
        this.valueOfColorPicker = this.grid.getSelectedRecords()[0].color;
        this.setState({
          inputName: name,
          inputDescription: desc,
          trade_type_id: tradeTypeId,
          rate1: rate1,
          rate2: rate2,
          rate3: rate3,
          rate4: rate4,
        });
        this.dialogOpenEdit();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
    if (args.item.id === 'delete') {
      if (this.grid.getSelectedRecords().length !== 0) {
        this.dialogOpenDelete();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
  }

  deleteTrade() {
    var theElements = this.grid.getSelectedRecords();
    if (theElements.length === 0) {
      Message.error('No record is selected to procced');
      return;
    }
    let obj = {
      trade_id: theElements[0].trade_id,
    };
    tradeDelete(obj)
      .then((result) => {
        if (result.status === 200) {
          loadingShow(false);
          Message.success('Deleted  successfully...');
          this.getTheTrades();
          this.dialogClose();
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
      });

    getTrades().then((result) => {
      this.setState({ TradesData: result.data });
    });

    this.dialogCloseDelete();
  }

  createTrade() {
    var tradeCode = this.state.inputName;
    var tradeDescription = this.state.inputDescription;
    var isExistBefore = this.tradeDataForFilterColor.findIndex((el) => {
      return el.color === this.valueOfColorPicker;
    });
    if (isExistBefore !== -1) {
      Message.error('Color must be uniq');
      loadingShow(false);
      return false;
    }
    if (tradeCode === '') {
      Message.error('Trade Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (tradeDescription === '') {
      Message.error('Trade Description cannot be empty');
      loadingShow(false);
      return false;
    }

    let obj = {
      trade_code: tradeCode,
      description: tradeDescription,
      trade_type_id: this.state.trade_type_id,
      color: this.valueOfColorPicker,
      rate1: this.state.rate1,
      rate2: this.state.rate2,
      rate3: this.state.rate3,
      rate4: this.state.rate4,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };
    createTrade(obj)
      .then((result) => {
        if (result.status === 200) {
          loadingShow(false);
          Message.success('Added successfully...');
          this.props.setTradeDataChanged(true);
          this.getTheTrades();
          this.dialogClose();
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Add failed!!!');
      });
  }
  renderColor(e: any) {
    return (
      <div
        style={{
          backgroundColor: e.color,
          width: '15px',
          height: '15px',
          borderRadius: '20%',
          marginLeft: '10%',
        }}
      ></div>
    );
  }
  render() {
    return (
      <div>
        <GridComponent
          dataSource={this.state.TradesData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.grid = g)}
          height='calc(-270px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          actionComplete={this.actionComplete.bind(this)}
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines={'Both'}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='color'
              headerText='#'
              textAlign='Left'
              width={30}
              template={this.renderColor.bind(this)}
            />
            <ColumnDirective
              field='trade_code'
              headerText='Trade Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
            />
            <ColumnDirective
              field='trade_type_id'
              headerText='ERP TradeID'
              textAlign='Left'
            />
            <ColumnDirective
              field='rate1'
              headerText='Rate 1'
              textAlign='Left'
            />

            <ColumnDirective
              field='rate2'
              headerText='Rate 2'
              textAlign='Left'
            />
            <ColumnDirective
              field='rate3'
              headerText='Rate 3'
              textAlign='Left'
            />
            <ColumnDirective
              field='rate4'
              headerText='Rate 4'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[Edit, Toolbar, Filter, Page, ColumnMenu, Resize, Group]}
          />
        </GridComponent>
        {this.state.hideEditDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogAddTeam'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideEditDialog}
            width={'400px'}
            header='Trade Editing'
            buttons={this.buttonsEdit}
            open={this.dialogOpenEdit.bind(this)}
            close={this.dialogCloseEdit.bind(this)}
          >
            <div className='row mb-3'>
              <div className='col-md-3'>Team Name:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  input={(e) => {
                    this.setState({ inputName: e.value });
                  }}
                  value={this.state.inputName}
                  placeholder='Enter Name'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Description:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  input={(e) => {
                    this.setState({ inputDescription: e.value });
                  }}
                  value={this.state.inputDescription}
                  placeholder='Enter Description'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>ERP TradeID:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  type='number'
                  input={(e) => { this.setState({ trade_type_id: e.value }); }}
                  value={this.state.trade_type_id?.toString()}
                  placeholder='Enter Trade Type ID'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Rate 1:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  type='number'
                  value={this.state.rate1?.toString()}
                  input={(e) => {
                    this.setState({ rate1: e.value });
                  }}
                  placeholder='$'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Rate 2:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  type='number'
                  value={this.state.rate2?.toString()}
                  input={(e) => {
                    this.setState({ rate2: e.value });
                  }}
                  placeholder='$'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Rate 3:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  type='number'
                  value={this.state.rate3?.toString()}
                  input={(e) => {
                    this.setState({ rate3: e.value });
                  }}
                  placeholder='$'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Rate 4:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  type='number'
                  value={this.state.rate4?.toString()}
                  input={(e) => {
                    this.setState({ rate4: e.value });
                  }}
                  placeholder='$'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Colour:</div>
              <div className='col-md-9'>
                <ColorPickerComponent
                  mode='Picker'
                  value={this.valueOfColorPicker}
                  change={(e: any) => {
                    this.valueOfColorPicker = e.value;
                  }}
                />
              </div>
            </div>
          </DialogComponent>
        ) : null}
        {this.state.hideDialogDelete ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideDialogDelete}
            header='Confirmation'
            width={200}
            height={'auto'}
            buttons={this.buttonsDelete}
            open={this.dialogOpenDelete.bind(this)}
            close={this.dialogCloseDelete.bind(this)}
          >
            <div className='container'>
              <div className='row'>
                <span>Are you sure?</span>
              </div>
            </div>
          </DialogComponent>
        ) : null}
        <div className='control-pane-dialogAdd'>
          <div
            id='targetElementAddTrades'
            className='col-lg-12 defaultDialogAddTrades dialog-target'
          >
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogAddTrades'
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                width={'400px'}
                height={'auto'}
                header='Trades'
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
              >
                <div className='row mb-3'>
                  <div className='col-md-3'>Trade Name:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      input={(e) => {
                        this.setState({ inputName: e.value });
                      }}
                      placeholder='Enter Trade Name'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Description:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      input={(e) => {
                        this.setState({ inputDescription: e.value });
                      }}
                      placeholder='Enter description'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>ERP TradeID:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      input={(e) => {
                        this.setState({ trade_type_id: e.value });
                      }}
                      placeholder='Enter Trade Type ID'
                    />
                  </div>
                </div>

                <div className='row mb-3'>
                  <div className='col-md-3'>Rate 1:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      type='number'
                      input={(e) => {
                        this.setState({ rate1: e.value });
                      }}
                      placeholder='Rate 1'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Rate 2:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      type='number'
                      input={(e) => {
                        this.setState({ rate2: e.value });
                      }}
                      placeholder='Rate 2'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Rate 3:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      type='number'
                      input={(e) => {
                        this.setState({ rate3: e.value });
                      }}
                      placeholder='Rate 3'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Rate 4:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      type='number'
                      input={(e) => {
                        this.setState({ rate4: e.value });
                      }}
                      placeholder='Rate 4'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Colour:</div>
                  <div className='col-md-9'>
                    <ColorPickerComponent
                      mode='Picker'
                      value={this.valueOfColorPicker}
                      change={(e: any) => {
                        this.valueOfColorPicker = e.value;
                      }}
                    />
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  tradeDataChanged: state.search.tradeDataChanged,
});

const mapDispatchToProps = (dispatch: any) => ({
  setTradeDataChanged: (value: boolean) => dispatch(setTradeDataChanged(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Teams);
